export default {
  'bindTo': 'this',
  'method': function(){
    alert('Inoltra AGYO')
  },
}
